<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
  <nav class="" id="vy_header ">
    <h1  v-on:click="home" style="cursor:pointer">
    
        <img id="by-logo" src="../../images/logo.png" alt="ボラ活エール" />
    </h1>
    <div class="container">

      <br/>
      
      <div v-on:click="manual_open" style="cursor:pointer"><u>まずはじめに</u><br>（<u>導入マニュアル</u>）</div>
      
      <br/>
        <button v-if="edit_update == 1"  class="btn btn-primary mx-aut" style="width: 100%; height: 50px;padding: 0;background-color: red;" v-on:click="update" >保存する</button>
        <button v-else class="btn btn-primary mx-aut" style="width: 100%; height: 50px;padding: 0;background-color: lightgrey;">保存する</button>


    </div>
  </nav>
</template>

<script setup>
/* eslint-disable */

  import { ref } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { login_check } from '../js/userdata_shakyo.js';
const router = useRouter();
let route = useRoute()
const cityname = route.params.shakyo
login_check()

  // 親コンポーネントから送られてきた値
  const props = defineProps(['param']);
  
  // 親（ShakyoHome）から送られたフラグによって保存ボタンの色を変える（edit_update = 0：未編集、1：編集、2：画面描画中につきボタンに影響させない）
  let edit_update = ref(props.param.edit_update) 

  // 親コンポーネントに送る値
  const emit = defineEmits(['call'])

console.log(edit_update.value)
// 更新ボタン
let update = function(){
  emit('call',{cmd:'update'});
}
//------------------------------ リンク --------------------------------
const home = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    router.push('/'+cityname+'/Kanri')
}
/*
const toiawase = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    //router.push('/Shakyo/toiawase')
}
const login = function() {
    //document.getElementById("vy_responsive_menu_close").click();
	login_check()
    router.push('/Shakyo/MailLogin')
}
const log_out = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    logout(); router.go('/Shakyo');
}
*/


let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/17bc0be34f8f80c9899bf966b87e0584?v=8fc1109df997461f978906bdc6784408"
    window.open(url,"_blank")
}
</script>
<style scoped>

</style>


